var _g;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgAddCircleOutlinedThick(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "18 / Outline /  Plus Circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41623 10.1111V7.58333H3.88845V6.41666H6.41623V3.88888H7.5829V6.41666H10.1107V7.58333H7.5829V10.1111H6.41623Z",
    fill: "var(--primary-4)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2218 6.99999C13.2218 10.4364 10.436 13.2222 6.99957 13.2222C3.56313 13.2222 0.777344 10.4364 0.777344 6.99999C0.777344 3.56355 3.56313 0.777771 6.99957 0.777771C10.436 0.777771 13.2218 3.56355 13.2218 6.99999ZM11.6662 6.99999C11.6662 9.57732 9.57689 11.6667 6.99957 11.6667C4.42224 11.6667 2.3329 9.57732 2.3329 6.99999C2.3329 4.42266 4.42224 2.33333 6.99957 2.33333C9.57689 2.33333 11.6662 4.42266 11.6662 6.99999Z",
    fill: "var(--primary-4)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleOutlinedThick);
export default __webpack_public_path__ + "static/media/addCircleOutlinedThick.07521f3f3a9bcf97d96635349b3fb0bb.svg";
export { ForwardRef as ReactComponent };